module.exports = __webpack_public_path__ + "img/psychologist.66b8f86f.svg";